import React from 'react';

const AuthHeader = () => {
  return (
    <div className="text-center mb-6 md:mb-8 lg:mb-10">
      <div className="flex justify-center mb-4 md:mb-6">
        <div className="w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 bg-primary/20 rounded-2xl flex items-center justify-center shadow-gaming-lg">
          <img
            src="/icon.png"
            alt="kkumhyeonlabs"
            className="w-10 h-10 md:w-12 md:h-12 lg:w-14 lg:h-14 object-contain"
            loading="eager"
            decoding="async"
          />
        </div>
      </div>
      <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground mb-2 md:mb-3">
        kkumhyeon.<span className="text-primary">labas</span>
      </h1>
      <p className="text-sm md:text-base lg:text-lg text-muted-foreground">
        목표를 게임처럼 달성하고 증명하세요
      </p>
    </div>
  );
};

export default AuthHeader;